import { FC, useEffect, useRef, useState } from "react";
import styles from "./CustomCheckbox.module.scss";
import CheckedIcon from "./assets/checkedIcon.svg";
import clsx from "clsx";

interface CustomCheckboxProps {
  id: string;
  data?: string[];
  allData?: string[];
  handleClickCheck?: (value: string, raws: string[]) => void;
  indeterminate?: boolean;
  dataTestId?: string;
}

const CustomCheckbox: FC<CustomCheckboxProps> = ({
  data = [],
  allData = [],
  id,
  handleClickCheck,
  indeterminate = false,
  dataTestId,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (id === "all") {
      if (data.length > 0 || allData.length > 0) {
        setIsChecked(Boolean(data.length === allData.length));
      }
    } else {
      setIsChecked(() => data.includes(id));
    }
  }, [data, id]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const handleClick = () => {
    setIsChecked((prev) => !prev);
    if (handleClickCheck) {
      handleClickCheck(id, data);
    }
  };

  return (
    <div className={styles.checkboxWrapper}>
      <label
        className={clsx(styles.checkboxLabel, {
          [styles.checked]: isChecked,
          [styles.indeterminate]: indeterminate,
        })}
      >
        {isChecked && (
          <CheckedIcon width={18} height={18} className={styles.checkedIcon} />
        )}
        <input
          className={styles.checkInput}
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={handleClick}
          ref={inputRef}
          {...(dataTestId ? { "data-testid": dataTestId } : {})}
        />
      </label>
    </div>
  );
};

export default CustomCheckbox;
